/**
 * Insulation painting brush settings, cached to remember the last selection
 * while the user stays on the drawing page.
 * @2026/08/17
 */

import { useState, ChangeEvent } from 'react';

import {
  getInsulationPaintingSetting as init,
  cacheInsulationPaintingSetting as cache,
} from '../state';
import {
  INSULATION_TYPE_OPTIONS,
  INSULATION_THICKNESS_OPTIONS,
  CLADDING_TYPE_OPTIONS,
} from '../types/insulation';

type ServeCategory = 'DUCT' | 'PIPE';

export const useInsulationPaintingSetting = () => {
  // initialize insulation painting settings from cache:
  const IPS = init();

  const [serveCategory, setServeCategory] = useState<ServeCategory>(
    IPS.serveCategory,
  );
  const [exposeType, setExposeType] = useState(IPS.exposeType);
  const [insulationType, setInsulationType] = useState(IPS.insulationType);
  const [thickness, setThickness] = useState(IPS.insulationThickness);
  const [claddingType, setCladdingType] = useState(IPS.claddingType);

  // cache new settings every rendering
  cache({
    serveCategory,
    exposeType,
    insulationType,
    insulationThickness: thickness,
    claddingType,
  });

  const categoryChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const category = event.target.value as ServeCategory;
    setServeCategory(category);
    // dependent option lists differ by category, reset to their first option
    setInsulationType(INSULATION_TYPE_OPTIONS[category][0].value);
    setThickness(INSULATION_THICKNESS_OPTIONS[category][0].value);
    setCladdingType(CLADDING_TYPE_OPTIONS[category][0].value);
  };

  return {
    serveCategory,
    exposeType,
    insulationType,
    thickness,
    claddingType,
    setExposeType,
    setInsulationType,
    setThickness,
    setCladdingType,
    categoryChangeHandler,
  };
};
